// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1v7Dk","list":"BalanceDue_list__3qcSq","listRow":"BalanceDue_listRow__3Im8m","total":"BalanceDue_total__2vrP5"};